import React, { Dispatch, SetStateAction } from 'react';
import './CreateRoomPopup.css';

export const CreateRoomPopup = ({ setCreateRoom }: { setCreateRoom: Dispatch<SetStateAction<string>> }) => {
    const countRooms = (e: React.MouseEvent<HTMLElement>, person: string) => {
        e.stopPropagation();
        setCreateRoom(person);
    };

    return (
        <div onClick={(e) => e.stopPropagation()} className="create-rooms">
            <button onClick={(event) => countRooms(event, '2')} className="create-rooms__button">
                <span className="create-rooms__text">На двух</span>
            </button>
            <button onClick={(event) => countRooms(event, '3')} className="create-rooms__button">
                <span className="create-rooms__text">На трех</span>
            </button>
            <button onClick={(event) => countRooms(event, '4')} className="create-rooms__button">
                <span className="create-rooms__text">На четырех</span>
            </button>
        </div>
    );
};
